<template>
  <tbody ref="container">
    <input
      ref="inputFile"
      type="file"
      class="d-none"
      accept="application/pdf"
      @change="addFile"
    />
    <tr v-if="added" class="row">
      <td class="col-md-4 text-left">
        <div class="firstElement">
          <span>{{ fileName }}</span>
        </div>
      </td>
      <td class="col-md-4 text-left">
        <div class="firstElement">
          <span>{{ fileTypeName }}</span>
        </div>
      </td>
      <td class="col-md-4 text-right">
        <button
          class="btn btn-dropdown-actions dropdown-toggle pt-1"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Acciones
        </button>
        <div class="dropdown-menu dropdown-menu-right pb-0">
          <!-- <a v-if="formMode === 1"
             class="drop-item"
             href="#"
             @click="$refs.inputFile.click()">
            <i class="fas fa-file-plus text-green pr-2"></i>
            <span>Editar</span>
          </a>-->
          <div v-if="added" class="dropdown-item" @click="downloadFile">
            <i class="fas fa-download text-green pr-2" />
            <span>Descargar</span>
          </div>
          <div
            v-if="formMode === 1 && added"
            class="dropdown-item"
            @click="onDeleteDocument()"
          >
            <i class="fas fa-times-circle text-red pr-1" />
            <span>Eliminar</span>
          </div>
        </div>
      </td>
    </tr>
    <tr v-if="!added" class="text-center">
      <td class="py2">
        No hay documento.
      </td>
    </tr>
    <div v-if="!added && formMode === 1" class="row justify-content-end">
      <ActionButton
        variant="success"
        i="fas fa-file-plus"
        @click="$refs.inputFile.click()"
      >
        Añadir
      </ActionButton>
    </div>
  </tbody>
</template>

<script>
import general from '@/services/pei/general';
import CustomAlert from '@/mixin/alert.mixin';
import ActionButton from '@/components/common/ActionButton';
export default {
  name: 'DocumentRow',
  mixins: [CustomAlert],
  components: {
    ActionButton,
  },
  props: {
    formMode: {
      type: Number,
      default: () => 1,
      required: true,
    },
    doc: {
      type: File,
      default: () => null,
    },
    objDoc: {
      type: Object,
      default: () => {},
    },
    fileTypeName: {
      type: String,
      default: () => 'Carta Afirmativa',
    },
  },
  data: () => ({
    isNewDoc: false,
  }),
  computed: {
    added() {
      return (
        this.doc != null ||
        (this.objDoc != null && this.objDoc.fileName != null)
      );
    },
    fileName() {
      return this.doc ? this.doc.name : this.objDoc.fileName;
    },
  },
  methods: {
    addFile() {
      this.$emit('addFile', this.$refs.inputFile.files[0]);
    },
    async onDeleteDocument() {
      let question = '¿Está seguro que desea eliminar el documento?';
      let alertResponse = await CustomAlert.methods.ShowCancelModal(
        'Atención',
        question,
        'Sí',
        'No'
      );
      if (alertResponse) {
        this.isNewDoc = true;
        this.$refs.inputFile.value = null;
        this.$emit('addFile', null);
        this.ShowToast(
          '',
          'Los datos fueron eliminados exitosamente.',
          'success'
        );
      }
    },
    downloadFile() {
      if (!this.objDoc || !this.objDoc.documentId || this.isNewDoc) {
        general.documentDownloadLocalFile(this.doc);
      } else if (this.objDoc && this.objDoc.documentId) {
        let binaryString = window.atob(this.objDoc.binary);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
          let ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }

        let blob = new Blob([bytes], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName_ = this.fileName;
        link.download = fileName_;
        link.click();
      }
    },
  },
};
</script>

<style scoped>
.firstElement {
  margin-left: 20px;
}
</style>
